import { useQuery } from "@tanstack/react-query";
import { MetosStation } from "services/iot/models";
import { createAuthService } from "services/serviceFactory";

const iotAuthService = createAuthService("iot");
const iotBase = "/iot/";

export const useMetosStationsQueries = () => {
    const results = useQuery({
        queryKey: ["iot", "metosStations"],
        queryFn: async () => {
            const response = await iotAuthService.post<MetosStation[]>(
                `${iotBase}Metos/GetMetosStationsAsync`
            );

            return response.data;
        },
    });

    const metosQuery = results;

    return {
        metosQuery,

        isLoading: results.isLoading,
        isError: results.isError,

        metosStations: metosQuery.data ?? [],
    };
};
